import template from "./spray_public_log.html";
import en from "./en.json";
import es from "./es.json";
import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import _ from "lodash";
import {
    SPRAY_APPLICATION_RECORD_STATUSES,
    getSprayApplicationRecordStatusTextClass,
} from "../../constants";

const AUTO_REFRESH_MINUTES = 5;
const MILLISECONDS_PER_MINUTE = 60 * 1000;

class SprayPublicLogController {
    /* @ngInject */
    constructor($timeout, $window) {
        this.$timeout = $timeout;
        this.$window = $window;
        this.LOGO_URL = logoUrl;
        this.autoRefreshTimer = null;
    }

    $onInit() {
        let ctrl = this;
        ctrl.inProgressStatusClass = getSprayApplicationRecordStatusTextClass(
            SPRAY_APPLICATION_RECORD_STATUSES.IN_PROGRESS,
        );
        ctrl.growerOrganizationName = _.get(
            _.first(ctrl.applicationRecords),
            "farm.grower_organization.name",
            "",
        );
        ctrl.records = _.orderBy(
            _.map(ctrl.applicationRecords || [], function (record) {
                return _.assign({}, record, {
                    locationDescription: _.map(record.fields, "name").join(
                        ", ",
                    ),
                });
            }),
            ["start_date"],
            ["desc"],
        );

        ctrl.autoRefreshTimer = ctrl.$timeout(function () {
            ctrl.$window.location.reload();
        }, AUTO_REFRESH_MINUTES * MILLISECONDS_PER_MINUTE);
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.autoRefreshTimer) {
            ctrl.$timeout.cancel(ctrl.autoRefreshTimer);
            ctrl.autoRefreshTimer = null;
        }
    }
}

export default {
    name: "sprayPublicLog",
    template: template,
    controller: SprayPublicLogController,
    bindings: {
        applicationRecords: "<",
    },
    translations: { en, es },
};
